import 'svelte-routing';
import { writable } from 'svelte/store';
import { boardAPIService } from './api/board.api.service';
class BoardService {
    constructor() {
        this.allBoards = writable([]);
        this.showAddBoardForm = writable(false);
    }
    async getAllBoards() {
        const allBoards = await boardAPIService.fetchAll();
        if ('error' in allBoards) {
            return [];
        }
        this.allBoards.set(allBoards);
    }
    async addBoard(payload) {
        const newBoard = await boardAPIService.create(payload);
        if ('error' in newBoard) {
            // throw error
            return;
        }
        this.allBoards.update((v) => [...v, newBoard]);
        this.toggleShowAddBoardForm(false);
    }
    toggleShowAddBoardForm(show) {
        if (show !== undefined) {
            this.showAddBoardForm.set(show);
            return;
        }
        this.showAddBoardForm.set(!this.showAddBoardForm);
    }
}
;
export const boardService = new BoardService;
